export default __webpack_public_path__ + "static/media/double-quotes.2017ffa9.svg";